import { goalChangeField } from 'shared/constants.json';
import { numberFields } from '@/lib/goal-change/format';

const time = (change) => new Date(change.changedAt).getTime();

// Numbers are stored without their unit. The unit a change was made in is the previous value of the next metric change
// after it, or the goal's current metric; a metric change in the same save only applies to the new value.
export const withMetrics = (changes, currentMetric) => {
  const metricChanges = changes.filter((c) => c.field === goalChangeField.metric).sort((a, b) => time(a) - time(b));
  const metricAfter = (at) => {
    const next = metricChanges.find((m) => time(m) > at);
    return next === undefined ? currentMetric : next.previousValue;
  };

  return changes.map((change) => {
    if (!numberFields.includes(change.field)) {
      return change;
    }
    const metric = metricAfter(time(change));
    const sameSave = metricChanges.find((m) => time(m) === time(change));
    return { ...change, metric, previousMetric: sameSave === undefined ? metric : sameSave.previousValue };
  });
};
